var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStandardChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ECC0B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 12.25V22.875C24.75 23.9105 23.9105 24.75 22.875 24.75H9.125C8.08945 24.75 7.25 23.9102 7.25 22.875V12.25H13.5V16.625C13.5 16.9688 13.7812 17.25 14.125 17.25H17.875C18.2188 17.25 18.5 16.9688 18.5 16.625L18.4648 12.25H24.75Z",
    fill: "#E34B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6535 7.25C10.1113 7.25 9.63789 7.5918 9.4668 8.10469L7.26465 12.2031C7.27197 12.2129 7.27686 12.2197 7.28174 12.2266C7.28662 12.2334 7.2915 12.2402 7.29883 12.25H13.5V16.625C13.5 17 13.75 17.25 14.125 17.25H17.875C18.25 17.25 18.5 17 18.5 16.625L18.4648 12.25H13.5L14.75 7.25H10.6535ZM22.5352 8.10469C22.3633 7.5918 21.8906 7.25 21.3477 7.25H17.25L18.4988 12.25H24.702C24.7093 12.2402 24.7142 12.2329 24.719 12.2256C24.7239 12.2183 24.7288 12.2109 24.7361 12.2012L22.5352 8.10469Z",
    fill: "#E34B31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardChecked);
export default __webpack_public_path__ + "static/media/standard-checked.fe6b12388908518d5b32be405d9221a2.svg";
export { ForwardRef as ReactComponent };